module.exports = __webpack_public_path__ + "img/logooseebmuriae.70aabb04.png";